import React from 'react'
import BookMarkSVG from '../icons/bookMarkSVG'
import ClockSVG from '../icons/clockSVG'
import SecuritySVG from '../icons/securitySVG'

const Features = () => {
  return (
    <section id="features">
      <div className="pt-16 pb-8 md:pt-12 layout-space lg:pt-20 xl:pt-32 xl:pb-32">
        <div className=" md:text-center md:mb-16">
          <h2 className="mb-3 heading">Mehr als eine Diktier-App</h2>
          <p className="mb-8 sub-heading">
            Produktivität-Features unterstützen Ihre Arbeit mit den Sprachaufnahmen und Transkripten, damit Sie in weniger Zeit mehr erreichen.
          </p>
        </div>
        <div className="max-w-6xl mx-auto md:flex lg:px-10">
          <div className="max-w-sm px-4 mx-auto mb-6 text-center bg-white shadow-xl xl:px-8 rounded-xl md:mx-2 md:flex-1 blue-dot-after">
            <div className="pt-6 pb-4">
              <ClockSVG className="w-12 h-12 mx-auto" />
            </div>
            <h3 className="uppercase bold sub-heading">TRANSKRIPT PER E-MAIL</h3>
            <h4 className="my-1 sub-heading text-accent bold">
              Innerhalb Von Minuten
            </h4>
            <p className="pb-6 small">
              Ihre Sprachmemos werden im Handumdrehen transkribiert und automatisch per E-Mail an Sie gesendet
            </p>
          </div>
          <div className="max-w-sm px-4 mx-auto mb-6 text-center bg-white shadow-xl xl:px-8 rounded-xl md:mx-2 md:flex-1">
            <div className="pt-6 pb-4">
              <SecuritySVG className="w-12 h-12 mx-auto" />
            </div>
            <h3 className="uppercase bold sub-heading">IMMER SICHER</h3>
            <h4 className="my-1 sub-heading text-accent bold">Immer Synchronisiert</h4>
            <p className="pb-6 small">
              Alle Meetings, Notizen, Sprachmemos und Transkripte werden als Backup in Ihre Cloud geladen (iCloud, Dropbox, Google Drive)
            </p>
          </div>
          <div className="max-w-sm px-4 mx-auto mb-6 text-center bg-white shadow-xl xl:px-8 rounded-xl md:mx-2 md:flex-1">
            <div className="pt-6 pb-4">
              <BookMarkSVG className="w-12 h-12 mx-auto" />
            </div>
            <h3 className="uppercase bold sub-heading">Marktführende Technik</h3>
            <h4 className="my-1 sub-heading text-accent bold">
              K.I. Spracherkennung
            </h4>
            <p className="pb-6 small">
              Transkription von Hand dauert Stunden. Ziehen Sie mehr aus Ihren Begegnungen und Meetings, indem Sie VoxRec Ihre Gespräche transkribieren lassen
            </p>
          </div>
        </div>
      </div>
    </section>
  )
}
export default Features
